// extracted by mini-css-extract-plugin
module.exports = {"icon":"ExpandableCard_icon__xLA4F","scriptIcon":"ExpandableCard_scriptIcon__2TsoU ExpandableCard_icon__xLA4F"};